import React, { useState } from 'react';
import { apiPost } from '../../api';
import { toast } from 'react-toastify';
import ConfirmationModal from '../../components/ConfirmationModal';

const AddUser = () => {
  const [form, setForm] = useState({
    name: '',
    surname: '',
    email: '',
    password: '',
    sponsor_id: ''
  });
  const [loading, setLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowConfirmModal(true);
  };

  const confirmAddUser = async () => {
    setLoading(true);
    try {
      // Sponsor is optional: send it only when filled, so an empty one isn't stored as ""
      const { sponsor_id, ...rest } = form;
      const sponsor = sponsor_id.trim();
      const res = await apiPost('/api/admin/user/add', sponsor ? { ...rest, sponsor_id: sponsor } : rest);
      if (res.data.success) {
        toast.success('User registered successfully');
        setForm({ name: '', surname: '', email: '', password: '', sponsor_id: '' });
        setShowConfirmModal(false);
      } else {
        toast.error(res.data.message || 'Failed to add user');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error adding user');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto">
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">
        <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
        Management
      </div>
      <h1 className="font-serif italic text-[45px] leading-[1.02] text-foreground mb-1">Add <span className="text-gradient-ginox">User</span></h1>
      <p className="text-sm text-muted-foreground mb-6">Register a new user account.</p>

      <div className="border-t border-white/[0.08] pt-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Name
            </label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="First name"
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
              required
            />
          </div>

          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Surname
            </label>
            <input
              name="surname"
              value={form.surname}
              onChange={handleChange}
              placeholder="Last name"
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
              required
            />
          </div>

          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Email
            </label>
            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="user@example.com"
              type="email"
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
              required
            />
          </div>

          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Password
            </label>
            <input
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Password"
              type="password"
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
              required
            />
          </div>

          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Sponsor ID (optional)
            </label>
            <input
              name="sponsor_id"
              value={form.sponsor_id}
              onChange={handleChange}
              placeholder="Sponsor ID"
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
            />
          </div>

          <div className="pt-2">
            <button
              type="submit"
              disabled={loading}
              className="rounded-md border border-ginox-green/60 bg-ginox-green/10 px-4 py-2 text-xs font-medium text-ginox-green hover:bg-ginox-green/20 transition-colors disabled:opacity-50"
            >
              {loading ? 'Adding...' : 'Add User'}
            </button>
          </div>
        </form>
      </div>

      <ConfirmationModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={confirmAddUser}
        title="Add User"
        message={`Are you sure you want to add user ${form.name} ${form.surname} with email ${form.email}?`}
        confirmText="Add User"
        loading={loading}
        loadingText="Adding..."
      />
    </div>
  );
};

export default AddUser;
